import { useEnabledFeatures } from '../../../common/hooks/enabled-features';
import { AdditionalInfoType } from '../../types';
import { PRO_QA_TYPES } from '~/additional-infos/event-panel-additional-infos/components/additional-info-row';

export type FilterConfig = {
    label: string;
    types: AdditionalInfoType[];
    testId: string;
    isDefaultEnabled: boolean;
    checkEnabled?: boolean;
};

export const useFilterConfig = (): Record<string, FilterConfig> => {
    const enabledFeatures = useEnabledFeatures();

    return {
        systemMessages: {
            label: 'System Messages',
            types: [AdditionalInfoType.SYSTEM],
            testId: 'ADDITIONAL_INFOS_FILTER_SYSTEM_CHECKBOX',
            isDefaultEnabled: !enabledFeatures.filterOutSystemMessagesFromNarrativeByDefault,
        },
        proqaUpdates: {
            label: 'ProQA Updates',
            types: PRO_QA_TYPES,
            testId: 'ADDITIONAL_INFOS_FILTER_PROQA_CHECKBOX',
            isDefaultEnabled: true,
            checkEnabled: enabledFeatures.proQaEnhancementsEnabled,
        },
    };
};
